import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { ProfileLayout } from 'pages/conversations/pages/search/pages/profile/layout/ProfileLayout'
import { ProfilePage } from 'pages/conversations/pages/search/pages/profile/ui/profilePage'

export const ProfileRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<ProfileLayout />}>
        <Route path={'/'} element={<ProfilePage />} />
        <Route path={'/:conversationId'} element={<ProfilePage />} />
      </Route>
    </RoutesWithNotFound>
  )
})
